import { Component } from '@angular/core';
import { Toast } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [Toast, RouterOutlet],
  template: `
    <div class="grid top-0 z-5 sticky mx-0 flex-none"></div>

    <div class="grid p-0 m-0 flex-nowrap flex-auto">
      <div class="col-12 pb-0">
        <p-toast />
        <router-outlet />
      </div>
    </div>
  `,
  host: { style: 'width: 100%; height: 100%; display: flex; flex-direction: column;' },
})
export class AuthLayoutComponent {}
